<!--
 * @Author: MX
 * @Date: 2020-07-30 14:24:16
 * @Description: 登录页
-->
<template>
  <div class="login" :class="carouselActive === 0 ? 'black' : ''">
      <div class="brower-contain" v-if="!isChrome">
        <span class="brower-contain-text">{{$lang('欢迎使用JMS科技信息平台')}}</span>
        <span class="brower-contain-text">{{$lang('请先下载安装谷歌浏览器')}}</span>
        <a class="brower-contain-btn" target="blank" href="https://www.google.cn/chrome/">{{ $lang('下载') }}</a>
    </div>
      <i class="iconfont iconLogo_zhankai"></i>
      <div class="lg-top">
          <div class="logo_introduce" >
              <div class="introduce_main">
                 {{$lang('J&T极兔速递秉承“客户为本，效率为根”的使命，积极拥抱互联网，采用最先进的智能分拣设备，布局大数据、人工智能、云计算和物联网。全力打造健康，长久的企业。')}}
              </div>
              <!-- <el-row class="introduce_num">
                  <el-col class="count" v-for="item in company" :key="item.key" :endVal="item.val" :span="item.span">
                      <div class="til">
                            {{item.name}}
                      </div>
                      <div class="num">
                          // <span>{{item.val}}</span>
                          <countTo :endVal='item.val' :duration='2000'></countTo>
                          <span>{{item.unit}}</span>
                      </div>
                  </el-col>
              </el-row> -->
          </div>
          <div v-if="!isSetPassword">
            <div class="login-box" v-if="!isForgetPassword && !isLoginSecondaryVerification">
                <!-- 添加国际化 -->
                <el-select class="lm-i18n" v-model="i18nValue" @change="i18nChange">
                    <el-option v-for="item in langList" :key="item.value" :value="item.value" :label="item.local"></el-option>
                </el-select>

                <div class="title">JMS-VIP</div>
                    <el-form ref="loginForm" :model="loginForm" :rules="rules">
                                    <el-form-item prop="account">
                                        <el-input  :placeholder="$lang('请输入账号')" v-model="loginForm.account"  type="text" autocomplete="off">
                                            <i slot="prefix" class="iconfont el-input__icon iconyonghuming"></i>
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item prop="pwd">
                                        <el-input :placeholder="$lang('请输入密码')"  v-model="loginForm.pwd" :type="showEye ? 'text' : 'password'" autocomplete="off">
                                            <i slot="prefix" class="iconfont el-input__icon iconmima1"></i>
                                            <img slot="suffix" class="eye-icon" :src="showEye ? eyeOpen : eyeClose" @click="handlerEye" alt="小眼睛">
                                        </el-input>
                                    </el-form-item>
                                    <!-- <el-form-item prop="captcha">
                                        <el-input :placeholder="$lang('请输入验证码')" v-model="loginForm.captcha" autocomplete="off" maxlength="11">
                                            <i slot="prefix" class="iconfont el-input__icon iconyanzhengma1"></i>
                                            <i slot="suffix">
                                                        <img :src="verificationImg" alt="" @click="resetCode" style="position: relative;bottom: 1px;">
                                            </i>
                                        </el-input>
                                    </el-form-item> -->
                                    <el-row>
                                        <el-checkbox v-model="remember" style="float:left">{{$lang('记住账号')}}</el-checkbox>
                                        <span class="forget" @click="forgetPassword">{{$lang('忘记密码')}}</span>
                                    </el-row>
                    </el-form>
                    <el-button type="primary" class="login-btn" @click="submitForm('loginForm')" v-loading="loginLoading">{{$lang('登 录')}}</el-button>
            </div>
            <div class="login-box" v-else-if="!isLoginSecondaryVerification">
              <ModifyPassword ref="ModifyPassword" @reBack="forgetPassword" @toverification ="verification"></ModifyPassword>
            </div>
            <div class="login-box" v-show="isLoginSecondaryVerification">
              <LoginSecondaryVerification ref="LoginSecond" @reBack="LoginSecondBack" :userData="userErrData" @secondLogin ="secondLogin" :loginForm="loginForm" />
            </div>
          </div>

          <div class="login-box" v-if="isSetPassword">
              <SetPasswordCom @setpasswordSuc="setpasswordSuc"></SetPasswordCom>
          </div>
      </div>
        <el-carousel height="100%" :initialIndex="carouselActive" trigger="click" :interval="6000" @change="(e)=> carouselActive = e" >
            <el-carousel-item v-for="item in carouselList" :key="item.key">
                <img :src="item.src" alt="" :key="item.key" width="100%" height="100%">
            </el-carousel-item>
        </el-carousel>
        <div class="footer">
            {{$lang('Copyright © 2019 - 2029 云路科技.All Rights Reserved')}}
       </div>

       <el-dialog class="cookieDialog"
               :show-close="false"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :destroy-on-close="true"
               width="600px"
               top="0"
               :visible.sync="cookieDialogVisibility">
      <p class="wrapper">
        {{$lang('我们希望在您的设备上存放Cookie及采用类似技术（“Cookie”），以提升用户体验，点击“我同意”，即表示您同意我们设置和使用所有Cookie，以及我们对利用Cookie收集的数据所采取的后续处理措施。')}}
        <span class="privacy" @click="showPrivacy">《{{$lang('隐私政策')}}》</span>
      </p>
      <div slot="footer"
            class="dialog-footer">
        <div>
          <el-button @click="disagreeCookie">{{$lang('不同意')}}</el-button>
          <el-button type="primary"
                     @click="agreeCookie"
                     class="confirm">{{$lang('同 意')}}</el-button>
        </div>
      </div>
    </el-dialog>

     <el-dialog class="privacyDialog"
                top="100px"
               :visible.sync="privacyVisible" >
      <privacy />
    </el-dialog>
    <el-dialog  :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"   top="100px" width="355px" :visible.sync="verificationVisible">
   <el-form ref="verificationToForm" class="ficationTodialog" :model="verificationToForm" :rules="rules">
     <el-form-item prop="captcha" class="verificationToForm">
              <el-input :placeholder="$lang('请输入图片验证码')" v-model="verificationToForm.captcha" autocomplete="off" maxlength="11">
                <i slot="prefix" class="iconfont el-input__icon iconyanzhengma1"></i>
                <i slot="suffix">
                  <img :src="verificationToImg" alt="" @click="getCode(true)" style="position: relative;bottom: 0px;left:0px">
                </i>
              </el-input>
            </el-form-item>
            </el-form>
            <div style="text-align: center;">
                <el-button  @click="verificationSubmit" type="primary" :loading="verificationLogin" >{{$lang('确 定')}}</el-button>
                  <el-button  @click="verificationVisible=false">{{$lang('取 消')}}</el-button>

            </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import bg1 from '@/assets/images/bg/bg1.jpg'
import bg2 from '@/assets/images/bg/bg2.jpg'
import bg3 from '@/assets/images/bg/bg3.jpg'
import eyeClose from '@/assets/images/eye_close.png'
import eyeOpen from '@/assets/images/eye_open.png'
import * as Api from '@api/base/public'
import { RULES } from '@utils/rules'
// import { LS } from '@utils/util'
import { RESPONSE_SUCCESS, MENU } from '@constants'
import ModifyPassword from './ModifyPassword'
import SetPasswordCom from './SetPasswordCom'
import LoginSecondaryVerification from './LoginSecondaryVerification'
import { mapActions } from 'vuex'
import privacy from './Privacy'
export default {
  name: 'Login',
  components: { ModifyPassword, SetPasswordCom, privacy, LoginSecondaryVerification },
  data() {
    return {
      eyeClose,
      eyeOpen,
      menuList: [...MENU],
      carouselActive: 1,
      userErrData: {},
      verificationToForm: {
        captcha: '',
        ctokenTo: ''
      },
      carouselList: [
        {
          key: 0,
          src: bg1
        },
        {
          key: 1,
          src: bg2
        },
        {
          key: 2,
          src: bg3
        }
      ],
      company: [
        { key: 0, name: this.$lang('转运中心'), val: 76, unit: '个', span: 5 },
        { key: 1, name: this.$lang('全国省市覆盖率'), val: 100, unit: '%', span: 8 },
        { key: 2, name: this.$lang('运输干线'), val: 900, unit: '+', span: 5 },
        { key: 3, name: this.$lang('长途运输车'), val: 400, unit: '+', span: 5 }
      ],
      loginForm: {
        account: '',
        pwd: '',
        captcha: ''
      },
      remember: false,
      verificationImg: '', // 验证码图片
      ctoken: '',
      isForgetPassword: false, // 是否忘记密码
      rules: {
        account: [{ required: true, message: this.$lang('用户名不能为空'), trigger: 'blur' }],
        pwd: [RULES.required],
        captcha: [RULES.required]
      },
      isSetPassword: false, // 首次登陆修改密码
      loginLoading: false, // 登录loading
      verificationLogin: false,
      verificationToImg: '', // 二次验证码图片
      verificationVisible: false,
      i18nValue: '',
      cookieDialogVisibility: false, // cookie提示信息弹窗
      privacyVisible: false, // 隐私信息提示弹窗
      isLoginSecondaryVerification: false, // 是否需要二次校验
      showEye: false
    }
  },
  created() {
    // this.getCode()
    this.init()
  },
  mounted() {
    this.initTencentCaptcha()
    if (window.sessionStorage && sessionStorage.getItem('cookieFlag') && sessionStorage.getItem('cookieFlag') === '1') {
      this.cookieDialogVisibility = false
    } else {
      setTimeout(() => {
        this.cookieDialogVisibility = true
      }, 520)
    }
  },
  computed: {
    // 国际化语言
    lang() {
      return this.$store.state.base.lang
    },
    // 国际化列表
    langList() {
      return this.$store.state.base.langList
    },
    isChrome() {
      return navigator.userAgent.toLowerCase().match(/chrome/)
    }
  },
  watch: {
    lang: {
      handler(val, oldVal) {
        this.i18nValue = val
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['SET_USER', 'LOGIN_INIT', 'SET_SYSTEM_MENU', 'SET_LANG', 'SET_LANG_JSON']),
    handlerEye() {
      this.showEye = !this.showEye
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      const LanguageList = { ES: 'es', EN: 'en', CN: 'zh-cn' }
      this.captcha = this.$Captcha.init(this.tencentCaptchaCallback, { userLanguage: LanguageList[this.lang] })
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res)
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        this.loginFn(customParams)
      }
      // 验证不成功
      return null
    },
    // 登录
    async loginFn(customParams) {
      const { account, pwd } = this.loginForm || {}
      // const ip = window.returnCitySN['cip'] || ''
      const params = {
        account,
        pwd: this.$md5(pwd + 'jadada236t2').toUpperCase(),
        ...customParams
        // captcha,
        // ctoken: this.ctoken,
        // ip
      }
      this.loginLoading = true
      Api.LOGIN(params).then(res => {
        if (res.code === 1) {
          this.loginLoading = false
          this.handleResForLogin(res)
        } else if (res.code === 149000013) {
          this.isLoginSecondaryVerification = true
          this.userErrData = res.data
          this.loginLoading = false
        } else {
          this.loginLoading = false
          this.$message.error(res.msg)
          this.resetCode()
        }
      })
    },
    // 是否同意收集cookie信息
    agreeCookie() {
      this.cookieDialogVisibility = false
      window.sessionStorage && sessionStorage.setItem('cookieFlag', '1')
    },
    disagreeCookie() {
      this.cookieDialogVisibility = false
      window.sessionStorage && sessionStorage.setItem('cookieFlag', '2')
    },
    // 显示隐私信息弹窗
    showPrivacy() {
      this.privacyVisible = true
    },
    // 初始化
    init() {
      // 在页面加载时从cookie获取登录信息
      const account = this.$common.getCookie('account')
      const prd1 = this.$common.getCookie('prd1')
      const prd2 = this.$common.getCookie('prd2')
      const prd3 = this.$common.getCookie('prd3')
      const password = prd1.substring(0, 3) + prd2.substring(0, 3) + prd3

      // 如果存在赋值给表单，并且将记住密码勾选
      if (account) {
        this.loginForm.account = account
        this.loginForm.pwd = password
        this.remember = true
      }
    },
    /**
     * @description 忘记密码
     */
    forgetPassword() {
      this.isForgetPassword = !this.isForgetPassword
      this.verificationVisible = false
      this.resetCode()
    },

    /**
       * 获取验证码
       */
    async getCode(type) {
      await Api.getCaptcha().then((res) => {
        if (type) {
          this.verificationToImg = res.data.img
          this.verificationToForm.ctokenTo = res.data.ctoken
        } else {
          this.verificationImg = res.data.img
          this.ctoken = res.data.ctoken
        }
      })
    },
    /**
       * 重新获取验证码
       */
    resetCode() {
      // this.getCode()
    },
    // 二次验证
    verification(type) {
      // alert(type)
      // console.log(type)
      if (!type) {
        this.verificationToForm.captcha = ''
        // this.getCode(true)
      }
      // this.$refs['verificationToForm'].resetFields()
      this.verificationLogin = false
      this.verificationVisible = !this.verificationVisible
    },
    verificationSubmit() {
      console.log(334343)
      // alert(334343)
      this.$refs['verificationToForm'].validate((valid) => {
        if (valid) {
          this.verificationLogin = true
          this.$refs.ModifyPassword.childMethod(this.verificationToForm)
        } else {
          return false
        }
      })
    },
    // 登录提交
    async submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.captcha.show()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 二次登录
    secondLogin(res) {
      this.handleResForLogin(res)
    },
    LoginSecondBack() {
      this.isLoginSecondaryVerification = false
      this.userErrData = {}
    },
    // 处理数据-登录成功后
    async handleResForLogin({ code, data, msg = '' } = {}) {
      // 请求成功
      if (code === RESPONSE_SUCCESS) {
        // 广播信息到其他同域名页面
        localStorage.setItem('YL_UPDATE', 'refreshOtherPage')
        // 数据为空
        if (!data) return
        // 解构对象
        const { firstLogin, type, freightStatus } = data
        // 去掉status判断（status：1启用2禁用）
        // 获取基础用户信息
        let user = { ...data }
        const token = data.token
        console.log(this.menuList)
        this.menuList.forEach(element => {
          if (type === 2 && element.routeName === 'userManage') {
            element.isShow = 2
          } if (freightStatus === 0 && element.routeName === 'workBench') {
            element.children[1].isShow = 2
          } else if (freightStatus === 1 && element.routeName === 'workBench') {
            element.children[1].isShow = 1
          } else if (type === 1) {
            element.isShow = 1
          }
        })
        this.menuList = JSON.parse(JSON.stringify(this.menuList))
        // 递归权限列表
        this.LOGIN_INIT({ user, token, systemMenus: this.menuList }).then(res => {
          if (!firstLogin) {
            Api.UserDetail({ id: user.id }).then((res) => {
              this.saveUserAccountInfoToCookie() // 记住密码
              if (res.code === RESPONSE_SUCCESS) {
                user = { ...data, ...res.data }
              }
              if (!user.contactMobile) {
                this.$router.push({ path: '/bindMobile' })
              } else {
                // 跳转路由
                this.$router.push({ path: '/index' })
                // 保存用户账号信息到cookie
                // this.saveUserAccountInfoToCookie() // 记住密码
                this.SET_USER(user) // 更新vuex的用户数据
                this.SET_SYSTEM_MENU(this.menuList)
              }
            })
          } else {
            localStorage.setItem('YL_TOKEN', '')
            localStorage.setItem('oldPwd', this.loginForm.pwd)
            // this.$router.push({ path: '/setPassword' })
            this.isSetPassword = true
          }
        })
      } else {
        this.resetVerify() // 重置验证码
        this.$message.error(msg)
      }
    },
    /**
     * @description 保存用户名密码
     */
    saveUserAccountInfoToCookie() {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      const { account, pwd } = this.loginForm
      if (this.remember) {
        // if (this.getCookie('password') === password) return
        let num1 = ''
        let num2 = ''
        for (var i = 0; i < 5; i++) {
          num1 += Math.floor(Math.random() * 10)
          num2 += Math.floor(Math.random() * 10)
        }
        const prd1 = pwd.length >= 3 ? pwd.substring(0, 3) + num1 : pwd.substring(0, 3)
        const prd2 = pwd.length >= 6 ? pwd.substring(3, 6) + num2 : pwd.substring(3, 6)
        const prd3 = pwd.substring(6)
        this.$common.setCookie('account', account, 7)
        this.$common.setCookie('prd1', prd1, 7)
        this.$common.setCookie('prd2', prd2, 7)
        this.$common.setCookie('prd3', prd3, 7)
      } else {
        this.$common.setCookie('account', '')
        this.$common.setCookie('prd1', '')
        this.$common.setCookie('prd2', '')
        this.$common.setCookie('prd3', '')
      }
    },
    // 初次登录修改密码成功
    setpasswordSuc() {
      this.isSetPassword = false
      this.isForgetPassword = false
      this.isLoginSecondaryVerification = false
      this.resetCode()
    },
    // 语言切换
    i18nChange(lang) {
      this.SET_LANG(lang)
    }
  }
}
</script>
<style lang="scss" scoped>
.black.login {
    color: #000;

}
.cookieDialog{
  .el-dialog__header{
    display: none;
    background: none !important;
    border-bottom: none !important;
  }
  .wrapper{
    font-size: 16px;
    font-family: PingFang, PingFang-SC;
    text-align: left;
    color: #2b2d42;
    line-height: 20px;
    font-weight: 600;
    .privacy{
      color: #698bf9;
      cursor: pointer;
    }
  }
}
.login {
  height: 100%;
  width: 100%;
  color: #fff;
  position: relative;
  // min-height: 720px;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  display: flex;
  align-items: center;
//   transition: color 1s;
  .iconLogo_zhankai {
    position: absolute;
    z-index: 2;
    top: 5%;
    left: 4.16667%;
    color: $--color-primary;
    font-size: 60px;
  }

 .lg-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-top: 110px;
    position: relative;
    z-index: 2;
  }
  .introduce_num{
        text-align: left;
        font-size: 24px;
    .num {
            margin-top: 21px;
            color: $--color-primary;
            letter-spacing: 0;
            word-spacing: 0;
            font-size: 36px;
            font-weight: 600;
        }
    }
   }
   .logo_introduce {
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    width: 1091px;
    padding-left: 100px;
    // word-break: break-all;
  }
  .login-box{
    position: relative;
    z-index: 2;
    color: #fff;
    background: rgba(10,0,17,.6);
    box-sizing: border-box;
    width: 572px;
      height: 540px;
      padding: 36px 106px;
      margin-right: 170px;
    border-radius: 15px;
    .title{
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
        text-align: center;
        letter-spacing: 6px;
        margin-bottom: 40px;
        height: 70px;
    }
    .forget {
      cursor: pointer;
      color: $--color-primary;
      text-decoration: none;
      float: right;
    }
    .login-btn{
         width: 100%;
        padding: 0;
        height: 40px;
        line-height: 40px;
        border: none;
        border-radius: 4px;
        background:linear-gradient(90deg,rgba(230,0,18,1) 0%,rgba(230,0,18,1) 100%);
         margin-top: 40px;
        font-size: 16px;
    }
    .eye-icon {
      width: 20px;
      height: 20px;
      cursor: pointer;
      margin-top: 10px;
    }
  }
  .introduce_main {
    font-size: 32px;
    line-height: 60px;
    margin-bottom: 80px;
    text-align: left;
    // letter-spacing: 9px;
   }

//    @media only screen and (min-width: 1920px) {
//     .logo_introduce {
//       width: 1091px;
//       padding-left: 100px;
//       word-break: break-all;
//       box-sizing: border-box
//     }
//     .login-box {
//       width: 572px;
//       height: 540px;
//       padding: 36px 106px;
//       margin-right: 170px;
//       box-sizing: border-box
//     }
//     .introduce_main{
//       letter-spacing: 9px;
//       font-size: 32px;
//       line-height: 80px;
//       margin-bottom: 133px;
//     }
//  }
 @media only screen and (max-width:1440px) {
    .logo_introduce {
      width: 771px;
      padding-left: 80px;
      box-sizing: border-box
    }
    .login-box {
      width: 501px;
      height: 524px;
      padding: 28px 70px;
      margin-right: 80px;
      box-sizing: border-box
    }
    .introduce_main{
        font-size: 30px;
    }
  }

</style>

<style lang="scss" rel="text/css">
$pl-input: 30px;
$mb-input: 20px;
$logo-h: 54px;
$border-color: #999999;
.lg-rgt-top {
  position: absolute;
  top: 20px;
  right: 20px;
}
::-webkit-input-placeholder {
  /* WebKit browsers */
  color: $border-color;
  font-size: 12px;
}
input:-internal-autofill-previewed,
input:-internal-autofill-selected {
    transition: background-color 5000s ease-in-out 0s !important;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: $border-color;
  font-size: 12px;
}

:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: $border-color;
  font-size: 12px;
}
html,
body {
  height: 100%;
}
.login{
    position: relative;
     .lm-i18n{
        position: absolute;
        right: 10px;
        top: 10px;
        width: 90px;
        .el-input__inner{
            padding: 0 15px !important;
            border-radius: 10px !important;
            border: 1px solid #999 !important;
            height: 32px !important;
            line-height: 32px !important;
        }
        .el-input__inner::placeholder,.el-input__inner::-webkit-input-placeholder{
            color: #fff;
        }
    }
    .el-form-item{
        margin-bottom:30px;
    }
    input:-webkit-autofill {
    /* 选择历史记录的文字颜色*/
        -webkit-text-fill-color: #fff !important;
    }
    .el-input{
        width: 100% !important;
    }
    input.el-input__inner{
            background: transparent;
            border: 0;
            border-radius: 0;
            border-bottom: 1px solid #fff;
            color: #fff !important;
            height: 40px;
            line-height: 40px;
            outline: none;

    }
     .verificationToForm{
     input.el-input__inner {
    background: transparent;
    border: 0;
    border-radius: 0;
    border: 1px solid #eee;
    border-color:#eee!important ;
    color: #909399 !important;
    height: 40px;
    line-height: 40px;
    outline: none;
  }
  }
    .el-checkbox__label{
        color: #fff;
    }
    .el-input__suffix{
        right: 0;
    }
    .el-carousel {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 0;
        width: 100%;
        min-width: 1200px;
        height: 100%;
    }
    .el-carousel__indicators{
        bottom: 6%;
    }
    .el-carousel__button{
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #d8d8d8;
    }
    .footer{
            position: absolute;
            bottom: 3%;
            text-align: center;
            font-size: 12px;
            font-family: ArialMT;
            width: 100%;
    }
    .el-input-group__append{
        color:#e60012;
       background: transparent;
        border:none;
        border-bottom:1px solid #fff
    }
    .el-form .el-input__inner{
        border-color:#fff !important;
    }
}
.brower-contain {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  width: 100%;
  height: 45px;
  line-height: 45px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  background-color:#333;
  z-index: 99;
  .brower-contain-text {
    margin-right: 30px;
  }
  .brower-contain-btn {
    @include base-color('clr');
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    display: inline-block;
    text-align: center;
    background:rgba(255,255,255,1);
    border-radius:2px;
    cursor: pointer;
    text-decoration:none;
    color: #000;
  }
}

</style>
